import { ToolkitPropertyRowMap } from '@aloft/toolkit-shared';

import { getTPFieldSortBy } from '../getTPFieldSortBy';
import { systemAccessorTPColumnDefs } from '../systemAccessorTPColumnDefs';
import {
  SystemAccessorTPColumnKey,
  TPColumnKey,
  TPTableSortBy,
  isSystemAccessorTPColumnKey,
} from '../types';

export function getTPSortBy(
  column: TPColumnKey | SystemAccessorTPColumnKey,
): TPTableSortBy<any> | undefined {
  return isSystemAccessorTPColumnKey(column)
    ? systemAccessorTPColumnDefs[column].sortBy
    : getTPFieldSortBy(ToolkitPropertyRowMap[column].type);
}
